// ⚠️ FICHIER TEMPORAIRE — À SUPPRIMER UNE FOIS L'API À JOUR EN PRODUCTION ⚠️
//
// Interrupteurs de fonctionnalités livrées côté front (merge PR #1152) alors que le back
// correspondant est resté sur `develop` : en production l'API ignore ces champs, la
// fonctionnalité est donc au mieux invisible, au pire trompeuse pour le membre.
//
// Chaque drapeau documente CE QU'IL FAUT EN PROD pour être repassé à `true`. Une fois l'API
// déployée : passer le drapeau à `true`, vérifier, puis RETIRER le drapeau ET ce fichier
// (`grep -rn "FEATURES" src/` donne la liste exhaustive des points d'accroche à nettoyer).
export const FEATURES = {
    // Mode incognito. Requiert côté API : la capability `canUseIncognito`, la route
    // `PATCH /users/me/set-toggle-incognito`, `incognitoTotal` sur les vues de story et la part
    // `incognito` des statistiques.
    // Sans elles : le sélecteur n'active rien et les offres vendent une fonctionnalité absente.
    INCOGNITO: false,

    // Titre facultatif d'une story. Requiert côté API : le champ `title` sur le schéma
    // EphemeralStory (création + lecture).
    // Sans lui : Mongoose écarte le champ en silence, le texte saisi par le membre est perdu à
    // la publication — c'est le seul des deux qui dégrade réellement l'expérience.
    STORY_TITLE: false,
};

export default FEATURES;
